import React, { PropTypes, PureComponent } from 'react';
import { isBlank } from 'underscore.string';
import TourneyTeamSelect from '../../../components/inputs/TourneyTeamSelect';
import NativeSelect from '../../../components/inputs/NativeSelect';
import cx from 'classnames';
import SearchInput from '../../../components/inputs/SearchInput';

const ID_NAME = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

const YES_NO_BOOL_OPTIONS = [ { id: 'true', name: 'Yes' }, { id: 'false', name: 'No' } ];

export const FILTER_DATA_SHAPE = PropTypes.shape({
  tourney: ID_NAME.isRequired,
  divisions: PropTypes.arrayOf(ID_NAME).isRequired,
  gameGroups: PropTypes.arrayOf(ID_NAME).isRequired,
  venues: PropTypes.arrayOf(ID_NAME).isRequired,
  courts: PropTypes.arrayOf(ID_NAME).isRequired,
  teams: PropTypes.arrayOf(ID_NAME).isRequired,
  dates: PropTypes.arrayOf(ID_NAME).isRequired
});

const gameGroupToString = ({ type, name }) => `${type}: ${name}`;
export const GameGroupSelect = props => (
  <NativeSelect
    getGroup={({ division: { name } }) => name}
    valueToString={gameGroupToString}
    optionToString={gameGroupToString}
    {...props}
  />
);

export const CourtSelect = props => (
  <NativeSelect
    getGroup={({ venue: { name } }) => name}
    {...props}/>
);

export default class AdminGamesFilter extends PureComponent {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    filterData: FILTER_DATA_SHAPE.isRequired
  };

  render() {
    const {
      value = {},
      onChange,
      filterData: { divisions, gameGroups, groupTypes, venues, courts, teams, dates }
    } = this.props;
    const { division, gameGroup, groupType, venue, court, team, incomplete, date, gameNameSearch, missingTeam } = value;

    const changed = change => onChange({ ...value, ...change });

    return (
      <div
        className={cx('display-flex align-items-center flex-wrap-wrap justify-content-center mg-bottom-xs')}
        style={{ margin: 'none' }}>
        <div className="mg-right-md mg-bottom-sm flex-grow-1">
          <label className="mg-right-sm">Name</label>
          <SearchInput
            placeholder="Game Name"
            value={gameNameSearch}
            onChange={gameNameSearch => changed({ gameNameSearch })}
          />
        </div>

        <div className="mg-right-md mg-bottom-sm flex-grow-1">
          <label className="mg-right-sm">Date</label>
          <NativeSelect value={date} onChange={date => changed({ date })} options={dates}/>
        </div>

        <div className="mg-right-md mg-bottom-sm flex-grow-1">
          <label className="mg-right-sm">Division</label>
          <NativeSelect
            value={division}
            onChange={division => changed({ division, gameGroup: null })}
            options={divisions}
          />
        </div>

        <div className="mg-right-md mg-bottom-sm flex-grow-1">
          <label className="mg-right-sm">Pool/Bracket</label>
          <GameGroupSelect
            value={gameGroup}
            options={gameGroups}
            onChange={gameGroup => changed({ gameGroup, division: gameGroup ? gameGroup.division : null })}
          />
        </div>

        <div className="mg-right-md mg-bottom-sm flex-grow-1">
          <label className="mg-right-sm">Group Type</label>
          <NativeSelect
            value={groupType}
            options={groupTypes}
            onChange={groupType => changed({ groupType, gameGroup: null })}/>
        </div>

        <div className="mg-right-md mg-bottom-sm flex-grow-1">
          <label className="mg-right-sm">Venue</label>
          <NativeSelect
            value={venue}
            onChange={venue => changed({ venue, court: null })}
            options={venues}
          />
        </div>

        <div className="mg-right-md mg-bottom-sm flex-grow-1">
          <label className="mg-right-sm">Court</label>
          <CourtSelect
            value={court}
            options={courts}
            onChange={court => changed({ court, venue: court ? court.venue : null })}/>
        </div>

        <div className="mg-right-md mg-bottom-sm flex-grow-1">
          <label className="mg-right-sm">Team</label>
          <TourneyTeamSelect
            showNumGames={false}
            teams={teams}
            autosize={false}
            multi={false}
            placeholder="Select..." value={team}
            onChange={team => changed({ team })}
            required={false}
          />
        </div>


        <div className="mg-right-md mg-bottom-sm flex-grow-1">
          <label>Incomplete</label>
          <NativeSelect
            value={_.findWhere(YES_NO_BOOL_OPTIONS, { id: `${incomplete}` })}
            options={YES_NO_BOOL_OPTIONS}
            onChange={incomplete => changed({ incomplete: incomplete && incomplete.id })}
          />
        </div>

        <div className="mg-right-md mg-bottom-sm flex-grow-1">
          <label>Missing Team</label>
          <NativeSelect
            value={_.findWhere(YES_NO_BOOL_OPTIONS, { id: `${missingTeam}` })}
            options={YES_NO_BOOL_OPTIONS}
            onChange={missingTeam => changed({ missingTeam: missingTeam && missingTeam.id })}
          />
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/GameDay/components/forms/AdminGamesFilter.jsx